import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import PageTracker from '../../../common/PageTrackerHelper'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  BasicSelect
} from 'vue-search-select';

export default {
  name: 'ShipmentUpdate',
  components: {
    VueElementLoading,
    Treeselect,
    Paginate,
    BasicSelect,
    PageTracker
  },
  mixins:[PageTracker],
  data: function() {
    return {
      ShipmentId: '',
      shipmenttype: [{
        text: "RTO"
      }, {
        text: "DTO"
      }, {
        text: "RVP"
      }, {
        text: "Delivery"
      }],
      userprocess: [{
        value: '1',
        text: "Allocate to SR"
      },{
        value: '2',
        text: "Out for delivery"
      }],
      shipmentObj: {
        // text: "",
        // value:""
      },
      processvalue : '',
      shipment: '',
      process: '',
      isLoading: false,
      userprocessobj: {
        text:"",
        value:""
      },
      userDataKey : '',
    }
  },
  created: function() {

  },
  async mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;

    //console.log('Mixin is working for :',result);
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.Update();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    Update() {
      this.input = {
        "shippingid": this.ShipmentId ,
        "ShipmetType": this.shipment,
        "userprocess": this.processvalue,
        "lastmodifiedby": this.localusermailid
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/update/Status/Shipment/Update',
          data: this.input
        })
        .then(async result => {
          if (result.data.code == 200) {
            let TrackerInfo = {
              projectname:"Last Mile",
              type:"Web",
              userid:this.localuserid,
              username:this.localusermailid,
              meta: {
                "event":"shipmentUpdate",
                "shippingid": this.ShipmentId.toString(),
                "ShipmetType": this.shipment,
                "userprocess": this.processvalue
              }
            }
            this.PageTracker(TrackerInfo);
            this.$alertify.success(result.data.message);
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
          this.clear();
        })
    },
    SelectShipmentType(obj) {
      this.shipmentObj = obj;
      this.shipment = obj.text;
    },
    SelectUserProcess(obj) {
        this.userprocessobj = obj;
        this.process = obj.text;
        this.processvalue = obj.value;
    },
    clear() {
      this.$validator.reset();
      this.ShipmentId = '';
      this.shipmentObj = {};
      this.userprocessobj = {
        text:"",
        value:""
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ShipmentUpdate/ShipmentUpdate.component.js